<script>
    import { metaInfo } from "@/core/MetaInfo";

    export default {
        name: "PreordersList",
        data() {
            return {
                list: [],
                offerList: [],
                versionsList: [],
                modelsList: [],
            };
        },
        mounted() {
            Promise.all([
                this.$store.autoAdminApi.getModels(),
                this.$store.autoAdminApi.getVersions(),
                this.$store.autoAdminApi.getOffers(),
            ]).then((data) => {
                this.modelsList = data[0].data.items;
                this.versionsList = data[1].data.items;
                this.offerList = data[2].data.items;
                this.getList();
            });
        },
        methods: {
            getName(id) {
                let offer = this.offerList.find((offer) => offer.id === id);

                let nameModel = this.modelsList.find(
                    (model) => model.id === offer.modelId
                ).name;
                let nameVersion = this.versionsList.find(
                    (version) => version.id === offer.versionId
                ).name;
                return nameModel + " " + nameVersion;
            },
            selected(item) {
                this.$router.push({ name: "PreorderEdit", params: { slug: item.id } });
            },
            getList() {
                this.$store.autoAdminApi.getPreorders().then(({ data }) => {
                    this.list = data.items;
                });
            },
            getStatus(value) {
                let filtered = {
                    closed: "Закрыт",
                    in_progress: "В процесс",
                    approved: "Утвержденный",
                    completed: "Завершенный",
                };
                return filtered[value];
            },
        },
        metaInfo() {
            return metaInfo.getMeta("home");
        },
    };
</script>

<template>
    <section class="section">
        <div class="field">
            <!--            <b-button tag="router-link" to="/testdrive-points/new" type="is-primary" outlined>-->
            <!--                Добавить точку-->
            <!--            </b-button>-->
        </div>

        <h1 class="title">Предзаказы</h1>
        <b-table :data="list" @select="selected" hoverable>
            <b-table-column
                field="offerId"
                label="Модель и комплектация"
                sortable
                v-slot="props"
            >
                {{ getName(props.row.offerId) }}
            </b-table-column>
            <b-table-column field="status" label="Статус" sortable v-slot="props">
                {{ getStatus(props.row.status) }}
            </b-table-column>
            <b-table-column field="contact.name" label="Имя" sortable v-slot="props">
                {{ props.row.contact.name }}
            </b-table-column>
            <b-table-column field="id" label="Id" sortable v-slot="props">
                {{ props.row.id }}
            </b-table-column>
        </b-table>
    </section>
</template>

<style lang="scss"></style>
